export enum ResourceName {
    
}